module.exports = __webpack_public_path__ + "img/renew_card2.6485551c.png";